export default __webpack_public_path__ + "static/media/element_31.6e85db70.jpg";